import React from "react";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, LineElement, PointElement, CategoryScale, LinearScale, Title, Tooltip, Legend } from "chart.js";

// Register chart components
ChartJS.register(LineElement, PointElement, CategoryScale, LinearScale, Title, Tooltip, Legend);


const AdminDashboard = () => {

    const statsRecord= [
        { label: "Total Submitted", stats: "Today's stats", color: "green" },
        { label: "Total Sent", stats: "Today's stats", color: "green" },
        { label: "Total Delivered", stats: "Today's stats", color: "green" },
        { label: "Total Failed", stats: "Today's stats", color: "red" },
        { label: "Total Submitted", stats: "Last 30 days stats", color: "green" },
        { label: "Total Sent", stats: "Last 30 days stats", color: "green" },
        { label: "Total Delivered", stats: "Last 30 days stats", color: "green" },
        { label: "Total Failed", stats: "Last 30 days stats", color: "red" },
      ];

      // Chart Data
  const lineData = {
    labels: ["Submitted", "Sent", "Delivered", "Failed"],
    datasets: [
      {
        label: "Statistics",
        data: [0.5, 0.8, 0.6, 0.2], // Sample data values
        borderColor: "#00BFFF",
        backgroundColor: "rgba(0, 191, 255, 0.2)",
        pointBorderColor: "#00BFFF",
        pointBackgroundColor: "#fff",
        tension: 0.3, // Smooth curve
      },
    ],
  };

  // Chart Options
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: true },
    },
    scales: {
      y: { beginAtZero: true },
    },
  };

  return (
    <div className="marginRight d-flex flex-column gap-4" style={{padding: '2rem 5rem' }}>
      {/* Breadcrumb */}
      <div className="d-flex align-items-center">
        
        <h1 className="text-muted"> Dashboard</h1>
      </div>

      {/* Stats Cards */}
      <div className="row g-3">
        {statsRecord.map((item, index) => (
          <div key={index} className="col-md-3">
            <div
              className="p-3 rounded d-flex justify-content-between align-items-center"
              style={{ background: "white", borderLeft: "3px solid #00BFFF", }}
            >
              <div>
                <h6 className="text-muted">{item.label}</h6>
                <h4>0</h4>
                <small style={{ color: item.color }}>{item.stats}</small>
              </div>
              <span
                className="badge"
                style={{
                  background: item.color === "red" ? "#ffcccc" : "#d4edda",
                  color: item.color === "red" ? "red" : "green",
                  fontSize: "1.2rem",
                }}
              >
                {item.color === "red" ? "✖" : "✔"}
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* Charts Section */}
      <div className="d-flex flex-wrap gap-3">
       {/* Message Volume Statistics */}
      <div className="d-flex" style={{flex:6}}>
        <div
          className="p-3 rounded d-flex flex-column align-items-center w-100"
          style={{
            background: "#fff",
          
            borderLeft: "3px solid #00BFFF",
            height: "300px",
          }}
        >
          <h6 className="text-muted">Message Volume Statistics</h6>
          <div style={{ width: "100%", height: "250px" }}>
            <Line data={lineData} options={options} />
          </div>
        </div>
      </div>

      {/* Today's Statistics */}
      <div className="d-flex" style={{flex:3}}>
        <div
          className="p-3 rounded d-flex flex-column align-items-center w-100"
          style={{
            background: "#fff",
            
            borderLeft: "3px solid #00BFFF",
            height: "300px",
          }}
        >
          <h6 className="text-muted">Today's Statistics</h6>
          <div style={{ width: "100%", height: "250px" }}>
            <Line data={lineData} options={options} />
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
